import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "chat-trigger" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Message = _resolveComponent("Message")!
  const _component_Button = _resolveComponent("Button")!
  const _component_GradientList = _resolveComponent("GradientList")!

  return (_openBlock(), _createElementBlock("footer", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_Button, {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isChatOpen = true)),
        type: "primary",
        style: {"width":"44px"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_Message)
        ]),
        _: 1
      }),
      (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.chat.component), {
        isMobile: "",
        "is-open": _ctx.isChatOpen,
        onClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isChatOpen = false))
      }, null, 40, ["is-open"]))
    ]),
    _createVNode(_component_GradientList)
  ]))
}